import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { judgeEmptyStr, judgeArr, judgeObj, toNumber } from '@/shared/functions';
import Api from '@/services';
import { notification } from 'antd';
const initState = {
    radios: [],
    m_radios: [{
            key: '增加',
            value: 'add',
        }, {
            key: '减少',
            value: 'sub',
        }],
    flowWater: false,
    desc: '',
    notPrice: false,
    noteTip: '请输入备注（选填，100字符内）',
    showChangeMoney: false,
    afterMoney: 0,
    shoudPayPrice: '',
    shoudPayDesc: '',
    higherPartPassMoney: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 确认
         */
        onOk(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { type, form } = payload;
                let fileds;
                let isGo = true;
                if (type === 'pass') {
                    isGo = yield this.checkMoney(payload);
                    if (isGo) {
                        fileds = ['desc', 'note'];
                    }
                    else {
                        fileds = ['desc', 'dealMoney', 'note'];
                    }
                }
                else if (type === 'charge') {
                    fileds = ['desc', 'money', 'note'];
                }
                else if (type === 'part_pass' && form.getFieldValue('partPassMoney')) {
                    fileds = ['desc', 'partPassMoney', 'note'];
                }
                else {
                    fileds = ['desc', 'note'];
                }
                form.validateFields(fileds, (errors, values) => {
                    if (!errors) {
                        if (isGo) {
                            this.requestDeal(payload);
                        }
                        else {
                            console.warn('未通过备注校验');
                        }
                    }
                    else {
                        console.warn('校验未通过的原因', errors);
                    }
                });
            });
        },
        /**
         * @desc 表单无误后，请求接口处理
         */
        requestDeal(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { type, form, orderId, onOk, price, isSeller } = payload;
                const { afterMoney, shoudPayPrice } = state;
                const v = form.getFieldsValue();
                let _param;
                switch (type) {
                    case 'confirm':
                        _param = {
                            receiveNum: orderId,
                            receiveForm: v.way,
                            tradeNum: v.desc,
                            remark: v.note,
                            frPrice: Number(price),
                        };
                        yield Api.finance.confirmBuyerPay(_param).then((_r) => {
                            if (_r) {
                                this.clear(payload);
                                notification.success({
                                    message: '确认付款成功',
                                });
                                onOk();
                            }
                            else {
                                notification.error({
                                    message: '确认付款失败',
                                });
                            }
                        });
                        break;
                    case 'pass':
                        _param = {
                            orderId,
                            payTypeCode: v.way,
                            swiftNo: v.desc,
                            remark: v.note,
                            payAmount: afterMoney ? Number(afterMoney) : Number(price),
                            operateAmount: v.dealMoney ? Number(v.dealMoney) : '',
                            operateType: v.isAdd === 'add' ? 1 : 0,
                        };
                        yield Api.order.sellerPayConfirm(_param).then((_r) => {
                            if (_r) {
                                this.clear(payload);
                                notification.success({
                                    message: '通过并打款成功',
                                });
                                onOk();
                            }
                            else {
                                notification.error({
                                    message: '通过并打款失败',
                                });
                            }
                        });
                        break;
                    case 'charge':
                        _param = {
                            soucheCode: orderId,
                            chargerType: v.way,
                            paySerial: v.desc,
                            remark: v.note,
                            money: Number(v.money),
                        };
                        if (isSeller) {
                            yield Api.finance.sellerCharge(_param).then((_r) => {
                                if (_r) {
                                    this.clear(payload);
                                    notification.success({
                                        message: '保证金充值成功',
                                    });
                                    onOk();
                                }
                                else {
                                    notification.error({
                                        message: '保证金充值失败',
                                    });
                                }
                            });
                        }
                        else {
                            yield Api.finance.buyerCharge(_param).then((_r) => {
                                if (_r) {
                                    this.clear(payload);
                                    notification.success({
                                        message: '保证金充值成功',
                                    });
                                    onOk();
                                }
                                else {
                                    notification.error({
                                        message: '保证金充值失败',
                                    });
                                }
                            });
                        }
                        break;
                    case 'refund':
                        _param = {
                            soucheCode: orderId,
                            chargerType: v.way,
                            paySerial: v.desc,
                            money: Number(price),
                        };
                        if (isSeller) {
                            yield Api.finance.sellerRefund(_param).then((_r) => {
                                if (_r) {
                                    this.clear(payload);
                                    notification.success({
                                        message: '保证金退款成功',
                                    });
                                    onOk();
                                }
                                else {
                                    notification.error({
                                        message: '保证金退款失败',
                                    });
                                }
                            });
                        }
                        else {
                            yield Api.finance.buyerRefund(_param).then((_r) => {
                                if (_r) {
                                    this.clear(payload);
                                    notification.success({
                                        message: '保证金退款成功',
                                    });
                                    onOk();
                                }
                                else {
                                    notification.error({
                                        message: '保证金退款失败',
                                    });
                                }
                            });
                        }
                        break;
                    case 'applyRefund':
                        _param = {
                            id: orderId,
                            optType: v.way,
                            paySerial: v.desc,
                        };
                        yield Api.finance.applyRefund(_param).then((_r) => {
                            if (_r) {
                                this.clear(payload);
                                notification.success({
                                    message: '保证金退款成功',
                                });
                                onOk();
                            }
                            else {
                                notification.error({
                                    message: '保证金退款失败',
                                });
                            }
                        });
                        break;
                    case 'part_pass':
                        _param = {
                            orderId,
                            payTypeCode: v.way,
                            swiftNo: v.desc,
                            remark: v.note,
                            payAmount: judgeEmptyStr(v.partPassMoney) ? Number(v.partPassMoney) : Number(shoudPayPrice),
                        };
                        yield Api.order.sellerPayment(_param).then((_r) => {
                            if (_r) {
                                this.clear(payload);
                                notification.success({
                                    message: '通过并打款成功',
                                });
                                onOk();
                            }
                            else {
                                notification.error({
                                    message: '通过并打款失败',
                                });
                            }
                        });
                        break;
                }
            });
        },
        /**
         * @desc 检查是否非打款金额，如果不是打款金额，并且没有备注信息，需要提示加备注
         */
        checkMoney(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { dealMoney, note } = payload.form.getFieldsValue(['dealMoney', 'note']);
                let passCheck = true;
                if (dealMoney !== undefined && Number(dealMoney) !== 0) {
                    if (payload.form.getFieldError('dealMoney')) {
                        passCheck = false;
                    }
                    // if note 有值 不抛错 如果没有 抛错
                    if (!judgeEmptyStr(note)) {
                        passCheck = false;
                        payload.form.setFields({
                            note: { value: note, errors: [new Error('打款金额有更改，请确认说明备注原因')] },
                        });
                    }
                    this.SET_NOTPRICE();
                }
                else {
                    payload.form.setFields({ note: { value: note } });
                    this.RESET_NOTPRICE();
                }
                return passCheck;
            });
        },
        /**
         * @desc 取消
         */
        onCancel(payload, { update, state, rootState }) {
            this.clear(payload);
            payload.onCancel();
        },
        /**
         * @desc 清空数据 设置所有errors为空
         */
        clear(payload, { update, state, rootState }) {
            // 关闭的时候 设置所有errors为空；
            payload.form.setFields({ note: {} });
            this.RESET_STATE();
            payload.form.resetFields();
        },
        /**
         * @desc 付款或退款方式切换
         */
        radioChange(payload, { update, state, rootState }) {
            const v = payload.v;
            payload.props.form.resetFields(['desc']);
            switch (v) {
                case '2':
                    this.SET_FLOWWATER('请输入凭证流水');
                    break;
                case '3':
                    this.SET_FLOWWATER('请输入转账流水');
                    break;
                case '1':
                case '4':
                    this.RESET_FLOWWATER();
                    break;
                default:
                    console.warn('付款确认的方式不存在');
            }
        },
        /**
         * @desc 检查备注的长度和是否必须输入备注
         */
        checkLen(payload, { update, state, rootState }) {
            const { props, value, callback } = payload;
            if (rootState.payMoneyModal.notPrice) {
                // 校验是否不等于应该的金额，此处目前仅type: pass使用
                const pattern = new RegExp(/[^\s]/);
                if (!pattern.test(value)) {
                    callback('打款金额有更改，请确认说明备注原因');
                }
            }
            const dealVal = value ? value.replace(/[\u4e00-\u9fa5]/g, 'aa') : '';
            if (dealVal.length > 100) {
                callback('限制最多100字符(中文占两个字符)');
            }
            callback();
        },
        /**
         * @desc 检查是否减去金额的时候超过打款金额
         */
        checkSub(payload, { update, state, rootState }) {
            // 如果是减去操作，确定金额是否查过打款金额
            const { afterMoney } = rootState.payMoneyModal;
            const { price } = payload.props;
            const { callback } = payload;
            const _p = afterMoney ? afterMoney : price;
            const _pDeal = Number(_p) ? Number(_p) : 0;
            if (_pDeal < 0) {
                callback('减少的金额不能大于打款金额');
            }
            callback();
        },
        /**
         * @desc 计算增加或减少输入的钱之后的钱
         */
        computeMoney(payload, { update, state, rootState }) {
            const { price, props } = payload;
            const { isAdd, dealMoney, note } = props.form.getFieldsValue(['isAdd', 'dealMoney', 'note']);
            if (dealMoney && Number(dealMoney) !== 0) {
                this.SET_NOTPRICE();
            }
            else {
                props.form.setFields({ note: { value: note } });
                this.RESET_NOTPRICE();
            }
            const _d1 = Number(price) ? Number(price) : 0;
            const _d2 = Number(dealMoney) ? Number(dealMoney) : 0;
            // switch (isAdd) {
            //   case 'add':
            //     this.SET_AFTERMONEY(Number(_d1 + _d2).toFixed(2));
            //     break;
            //   case 'sub':
            //     this.SET_AFTERMONEY(Number(_d1 - _d2).toFixed(2));
            //     break;
            // }
            this.SET_AFTERMONEY(Number(_d1 - _d2).toFixed(2));
        },
        /**
         * @desc 获取radios值
         */
        getPayRadios(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                let { type } = payload;
                type = type ? type : 'confirm';
                const localItem = (type === 'refund' || type === 'pass' || type === 'applyRefund') ? 'WAY_RADIO_REFUND' : 'WAY_RADIO_PAY';
                const radios = JSON.parse(localStorage.getItem(localItem) || JSON.stringify(''));
                if (!judgeArr(radios)) {
                    const typeId = (type === 'refund' || type === 'pass' || type === 'applyRefund') ? 10 : 4;
                    yield Api.base.getKeyValue({ typeId }).then((_r) => {
                        if (judgeArr(_r)) {
                            const _d = JSON.parse(JSON.stringify(_r)).map((item) => {
                                return {
                                    key: item.value,
                                    value: item.keyName,
                                };
                            });
                            localStorage.setItem(localItem, JSON.stringify(_d));
                            this.SET_STATE({
                                radios: _d,
                            });
                        }
                    });
                }
                else {
                    this.SET_STATE({
                        radios,
                    });
                }
            });
        },
        /**
         * @desc 获取分批通过并打款的 打款金额和描述
         */
        getPartPassPriceAndDesc(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { orderId, params } = payload;
                const _param = Object.assign({ orderId }, params);
                yield Api.order.getOrderPaymentAmount(_param).then((_r) => {
                    const data = JSON.parse(JSON.stringify(_r));
                    if (judgeObj(data)) {
                        const { payAmountY, payTxt } = data;
                        this.SET_STATE({
                            shoudPayPrice: payAmountY,
                            shoudPayDesc: payTxt,
                        });
                    }
                });
            });
        },
        /**
         * @desc 分批通过并打款的 是否高于应打款金额
         */
        isHigherPartPassMoney(payload, { update, state, rootState }) {
            const { form } = payload;
            const { shoudPayPrice } = state;
            if (judgeEmptyStr(shoudPayPrice)) {
                this.SET_STATE({
                    higherPartPassMoney: toNumber(shoudPayPrice) < toNumber(form.getFieldValue('partPassMoney')),
                });
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_NOTPRICE(state, payload) {
            state.notPrice = true;
        },
        RESET_NOTPRICE(state, payload) {
            state.notPrice = false;
        },
        SET_FLOWWATER(state, payload) {
            state.flowWater = true;
            state.desc = payload;
        },
        RESET_FLOWWATER(state, payload) {
            state.flowWater = false;
        },
        SET_SHOW_CHANGE_MONEY(state, payload) {
            state.showChangeMoney = !state.showChangeMoney;
        },
        SET_AFTERMONEY(state, payload) {
            state.afterMoney = payload;
        },
    },
});
